import * as yup from 'yup';

export function kpiCollectionConfigurationFields() {
  return {
    id: yup.string(),
    kpiIds: yup
      .array()
      .nullable()
      .of(yup.number().required())
      .min(1, 'Please select at least one KPI')
      .default([]),
    name: yup.string().required().default(''),
  };
}

export function kpiCollectionConfigurationSchema() {
  return yup.object(kpiCollectionConfigurationFields());
}
export type KpiCollectionConfiguration = yup.InferType<ReturnType<typeof kpiCollectionConfigurationSchema>>;

export type KpiCollectionConfigurationResponse = Required<KpiCollectionConfiguration>;

export function createKpiCollectionConfigurationModel(
  overrides: Partial<KpiCollectionConfiguration> = {}
): KpiCollectionConfiguration {
  return { ...kpiCollectionConfigurationSchema().getDefault(), ...overrides };
}
